var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sale)?_c('b-form-checkbox',{staticClass:"m-t-15",attrs:{"value":1,"unchecked-value":0},model:{value:(_vm.update_unidades_devueltas),callback:function ($$v) {_vm.update_unidades_devueltas=$$v},expression:"update_unidades_devueltas"}},[_vm._v(" Actualizar unidades devueltas en los items de la venta ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }